/** @module Export/ImportCoverageIn */
define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/view/ToolbarFind",  // required support toolbar search on the view
	"./ImportCoverageStores"
], function(declare,Table,ToolbarFind,ImportCoverageStores) {

	return declare(Table, {
		disableCustomViewToolbar: true,
		findAttributes: ["Node Name","ExportClassLocalized"],
		plugins: ["find","tableExcel"],
		pluginsRight: [],
		store: ImportCoverageStores.In,
		bResetStore: false
	});
});